import { render, staticRenderFns } from "./DdfVote.vue?vue&type=template&id=687c3ea6&scoped=true&"
import script from "./DdfVote.vue?vue&type=script&lang=js&"
export * from "./DdfVote.vue?vue&type=script&lang=js&"
import style0 from "./DdfVote.vue?vue&type=style&index=0&id=687c3ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687c3ea6",
  null
  
)

export default component.exports